// Usage: When the subscription resources are loaded, a target gets loaded that
// notifies this controller if payment is needed or not. This controller will
// then update the UI accordingly.
//
// Example:
//
// <div data-controller="payment-checker">
// </div>
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "message", "needsPayment", "paymentOk"]

  needsPaymentTargetConnected() {
    this.submitTargets.forEach(e => e.disabled = true)
    this.messageTargets.forEach(e => e.classList.remove("hidden"))
  }

  paymentOkTargetConnected() {
    this.submitTargets.forEach(e => e.disabled = false)
    this.messageTargets.forEach(e => e.classList.add("hidden"))
  }
}
